import { render, staticRenderFns } from "./LeaderboardList.vue?vue&type=template&id=45b289c2&scoped=true"
import script from "./LeaderboardList.vue?vue&type=script&lang=js"
export * from "./LeaderboardList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b289c2",
  null
  
)

export default component.exports